import {
  packageVersionTasks,
  servicePackages,
  servicePackageVersions,
} from '../servicePackage'
import { describeTable } from './describeTable'

describeTable(servicePackages, {
  description: `A sellable subscription package (huoltopaketti) in the catalogue — the thing a huoltosopimus is composed of. Prices and contents live on service_package_versions; a package's current price is its version with is_active = true. Mirrored to Stripe as a product. Applicability by floor area limits which packages the resident app offers for a given house.`,
  columns: {
    packageType:
      'fixed_bundle = a fixed set of tasks at one price; configurable_item = a per-unit add-on the customer picks a quantity of.',
    applicableAreaMin:
      'Minimum property floor area (m²) this package is offered for; NULL = no minimum.',
    applicableAreaMax: 'Maximum floor area (m²); NULL = no maximum.',
    stripeProductId: 'Stripe product id, set by the stripe:sync script.',
  },
})

describeTable(servicePackageVersions, {
  description: `A priced revision of a service package. A new version is created instead of editing the price, so old subscriptions keep the version they were sold on. Exactly one version per package should be is_active; valid_from / valid_until bound when it could be sold. Contents = package_version_tasks.`,
  columns: {
    versionNumber: 'Sequential per package.',
    priceMonthly:
      'Monthly price in euros in the same unit as subscriptions.effective_price_monthly (gross, VAT included).',
    validFrom: 'Calendar date the version became sellable.',
    validUntil:
      'Calendar date it stopped being sellable; NULL = still current.',
    isActive:
      'The version currently offered for sale; older versions stay for existing contracts.',
    stripePriceId:
      'Stripe price id for this version, set by the stripe:sync script.',
  },
})

describeTable(packageVersionTasks, {
  description:
    'Which maintenance_tasks a package version includes and how often they recur. Join maintenance_tasks for the service name and category.',
  columns: {
    frequency:
      "Cadence keyword: 'monthly', 'quarterly', 'biannually', 'annually', a season ('spring', 'summer', 'fall', 'winter'), or NULL = one-time / use maintenance_tasks.default_frequency_days.",
    sortOrder: 'Display order only.',
  },
})
